import { IconContentList } from '@doltech/icons/IconContentList';
import * as React from 'react';
import styled from 'styled-components';

import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { IconCourseInfoOutline } from '@doltech/icons/IconCourseInfoOutline';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Box } from '@doltech/ui/lib/figma/Common/BoxV2';
import { shadows } from '@doltech/ui/lib/figma/shadows';
import { GrammarTOCDrawer, TOCDrawerProps } from './GrammarTOCDrawer';
import dynamic from 'next/dynamic';

const StudentDoGrammarInfoDrawer = dynamic<any>(
  () => import('./StudentDoGrammarInfoDrawer').then((c) => c.StudentDoGrammarInfoDrawer),
  {
    ssr: false,
  }
);

const LAYOUT = {
  FILL: 'fill',
  RESPONSIVE: 'responsive',
} as const;

const Action = styled.div`
  padding: 4px;
  color: ${colorsV2.gray100};
  border-radius: 4px;

  &:not(:last-child) {
    margin-right: 24px;
  }
`;

const ActionGroup = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  width: 100%;
`;

const Container = styled.aside`
  position: fixed;
  bottom: 20px;
  right: 16px;
  min-height: 52px;
  background-color: ${colorsV2.white100};
  border-top: 1px solid ${colorsV2.gray20};
  border-radius: 40px;
  box-shadow: ${shadows.zIndex4};

  z-index: 10;
  ${fromScreen(451)} {
    display: none;
  }
`;

export interface InteractionBottomNavigationProps
  extends Pick<TOCDrawerProps, 'scrollContainerElm'> {
  layout?: (typeof LAYOUT)[keyof typeof LAYOUT];
  pageId?: string;
  pageUrl?: string;
  tooltipColor?: string;
  tocTitle?: string;
  tocItems?: TOCDrawerProps['items'];
  tocEditorItems?: TOCDrawerProps['editorItems'];
  detailInfo?: React.ReactNode;
}

export const InteractionBottomNavigation = (props: InteractionBottomNavigationProps) => {
  const {
    layout = LAYOUT.FILL,
    tocTitle,
    tocItems,
    tocEditorItems,
    scrollContainerElm,
    detailInfo,
  } = props;

  const isFill = layout === LAYOUT.FILL;
  const [tocVisible, setTocVisible] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const isValidTocItems = tocEditorItems?.length > 0 || tocItems?.length > 0;

  return (
    <Container>
      <ActionGroup maxWidth={isFill ? '100%' : ['100%', '140px']}>
        <Action onClick={() => setVisible(true)}>
          <IconCourseInfoOutline fontSize={24} color="gray180" />
          <StudentDoGrammarInfoDrawer
            visible={visible}
            onClose={(e) => {
              e.stopPropagation();
              setVisible(false);
            }}
            tocTitle={tocTitle}
            items={tocItems}
            editorItems={tocEditorItems}
            scrollContainerElm={scrollContainerElm}
          >
            {detailInfo}
          </StudentDoGrammarInfoDrawer>
        </Action>
      </ActionGroup>
      {isValidTocItems && (
        <ActionGroup maxWidth="96px">
          <Action onClick={() => setTocVisible(true)}>
            <IconContentList fontSize={24} color="gray180" />
            <GrammarTOCDrawer
              visible={tocVisible}
              onClose={(e) => {
                e.stopPropagation();
                setTocVisible(false);
              }}
              tocTitle="Nội dung bài viết"
              items={tocItems}
              editorItems={tocEditorItems}
              scrollContainerElm={scrollContainerElm}
            />
          </Action>
        </ActionGroup>
      )}
    </Container>
  );
};
